import { RouteRecordRaw } from 'vue-router';
import LoginView from '~views/LoginView.vue';
import PageNotFound from '~views/PageNotFound.vue';
import DashboardView from '~views/DashboardView.vue';
// eslint-disable-next-line import/no-cycle
import CalendarView from '~views/CalendarView.vue';

const routes: RouteRecordRaw[] = [
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    component: PageNotFound,
  },
  {
    path: '/',
    redirect: '/login',
    name: 'home',
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
  },
  {
    path: '/dashboard',
    name: 'DashboardView',
    component: DashboardView,
    meta: { requiresAuth: true },
  },
  {
    // Вход виджета из iframe: ?id_patient=...&con_str={...}
    path: '/catch',
    name: 'Catch',
    component: CalendarView,
  },
];

export default routes;
